import { MobileContentGems } from '@mc/api'
import { Tile, TileCaption, TileImage } from '@mc/design-system'
import { TrackingContainer } from '@mc/visibility'
import { INITIAL_FONT_SIZE } from 'pages/classes/[slug]/hooks/useStickyCardsStack'
import styles from './StickyCard.module.scss'

type StickyCardMobileProps = {
  gem: MobileContentGems
  index: number
  isLastCard: boolean
  cardRef: (el: HTMLDivElement | null) => void
  onCardViewed: () => void
  isStacked?: boolean
}

export const StickyCardMobile = ({
  gem,
  index,
  isLastCard,
  cardRef,
  onCardViewed,
  isStacked = false,
}: StickyCardMobileProps) => {
  const stickyTop = isStacked ? index * 60 : (index + 1) * 60

  return (
    <div
      ref={cardRef}
      className={`col-12 position-relative ${styles.stickyCard} ${isStacked ? styles.stacked : ''}`}
      style={
        {
          '--sticky-top': `${stickyTop}px`,
          '--sticky-z-index': index,
        } as React.CSSProperties
      }
    >
      <TrackingContainer
        onFirstVisible={onCardViewed}
        config={{
          threshold: 0.9,
        }}
      >
        <div className='mc-p-2'>
          <Tile
            aspectRatio='auto'
            className='mc-corners--md mc-overflow--hidden'
            style={{
              aspectRatio: '51/64',
            }}
          >
            <TileCaption position='left top' padding={4}>
              <div
                className='mc-bg-primary mc-corners--circle d-flex align-items-center justify-content-center'
                style={{
                  width: 30,
                  height: 30,
                }}
              >
                {index + 1}
              </div>
            </TileCaption>

            <TileImage imageUrl={gem.imageUrl} alt='' />
            <div className={styles.blurOverlay} />

            {!isLastCard && (
              <div className={`position-absolute ${styles.overlay}`} />
            )}

            <div
              className={`position-absolute d-flex align-items-center justify-content-center mc-text--center ${styles.title}`}
              style={{
                fontSize: `${INITIAL_FONT_SIZE}px`, // initial font size value
              }}
            >
              <span className='mc-text--bold'>{gem.title}</span>
            </div>
          </Tile>
        </div>
      </TrackingContainer>
    </div>
  )
}
